import React, { ReactNode } from "react"

import { Box } from "wealthmode-frontend/gluestack/ui"

type ColHeader = {
  id: string
  shrink?: boolean
  noTruncate?: boolean
}

function TableColGroup({ header }: { header: ColHeader[] }) {
  return (
    <colgroup>
      {header.map((hdr) => (
        <col key={hdr.id} />
      ))}
    </colgroup>
  )
}

/**
 * Single table so header and body columns share one layout. Column headers use
 * sticky positioning inside the vertical scroll area (not a separate table).
 */
export function TableScrollLayout({
  header,
  headerRow,
  children,
}: {
  header: ColHeader[]
  headerRow: ReactNode
  children: ReactNode
}) {
  return (
    <Box className="flex flex-1 min-h-0 flex-col overflow-hidden w-full min-w-0">
      <Box className="flex-1 min-h-0 overflow-x-auto overflow-y-auto w-full min-w-0">
        <table className="w-full table-auto border-separate border-spacing-0">
          <TableColGroup header={header} />
          <thead>
            <tr className="border-b border-border-medium">{headerRow}</tr>
          </thead>
          <tbody className="divide-y divide-border-medium">{children}</tbody>
        </table>
      </Box>
    </Box>
  )
}
